export default [
  {
    name: 'MotivaAi',
    date: '02/2018',
    online: true,
    opensource: true,
    repo: 'https://github.com/nandomoreirame/motivaai',
    image: 'motivaai.png',
    url: 'https://nandomoreirame.github.io/motivaai/',
    description: `💪 Uma frase de motivação pra dar um UP no seu dia!`,
    tags: [
      'ES6',
      'ECMAScript6',
      'OpenSource',
      'Frontend',
      'Netlify'
    ]
  },
  {
    name: 'Projeto nandomoreira.me',
    date: 'Em eterna construção...',
    online: true,
    opensource: true,
    repo: 'https://github.com/nandomoreirame/nandomoreira.me',
    image: 'nandomoreira.me.png',
    url: 'https://github.com/nandomoreirame/nandomoreira.me',
    description: `🏃 My superfast personal site using Nuxtjs/Vuejs -- Projeto escrito em VueJS utilizando NuxtJS para gerar os arquivos estáticos e hospeda-los n0 Netlify. O código é totalmente Open Source sob licença MIT.`,
    tags: [
      'VueJS',
      'Vuex',
      'NuxtJS',
      'ECMAScript6',
      'OpenSource',
      'Netlify'
    ]
  },
  {
    name: 'Vovó Juju falas',
    date: '02/2019',
    online: true,
    opensource: true,
    repo: 'https://github.com/nandomoreirame/vovo-juju-ipsum',
    image: 'vovojuju.nandomoreira.me.png',
    url: 'https://vovojuju.nandomoreira.me/',
    description: `Gerador de falas da fofa da vovó Juju (animação Irmão do Jorel) 🥑 Projeto open-source foi escrito em VueJS, Vuex, Stylus e muita criatividade!`,
    tags: [
      'VueJS',
      'Vuex',
      'ECMAScript6',
      'OpenSource',
      'Netlify'
    ]
  },
  {
    name: 'Blog nandomoreira.me',
    date: '12/2018',
    online: true,
    opensource: true,
    repo: 'https://github.com/nandomoreirame/blog.nandomoreira.me',
    image: 'blog.nandomoreira.me.png',
    url: 'https://blog.nandomoreira.me',
    description: `Projeto escrito em Jekyll para gerar os arquivos estáticos e hospeda-los no Netlify. O código é totalmente Open Source sob licença MIT.`,
    tags: [
      'Ruby',
      'Jekyll',
      'ECMAScript6',
      'StaticGen',
      'OpenSource',
      'Netlify'
    ]
  },
  {
    name: 'Underconstruction Static HTML',
    date: '12/2018',
    online: true,
    opensource: true,
    repo: 'https://github.com/nandomoreirame/underconstruction-static-html',
    image: 'underconstruction-static-html.png',
    url: 'https://starter-kit.netlify.com/',
    description: `Under construction is a free template static html using Gulp starter-kit`,
    tags: [
      'Free',
      'Gulp',
      'Gulpjs',
      'Babel',
      'Pug',
      'ECMAScript6',
      'StaticGen',
      'Stylus',
      'OpenSource',
      'Netlify'
    ]
  },
  {
    name: 'Gulp starter-kit',
    date: '12/2018',
    online: true,
    opensource: true,
    repo: 'https://github.com/onedevstudio/starter-kit',
    image: 'starter-kit.png',
    url: 'https://starter-kit.netlify.com/',
    description: `Starter Kit is a simple front-end starter-kit with Babel, Gulpjs, Pug and Stylus`,
    tags: [
      'Gulp',
      'Gulpjs',
      'Babel',
      'Pug',
      'ECMAScript6',
      'StaticGen',
      'Stylus',
      'OpenSource',
      'Netlify'
    ]
  },
  {
    name: 'App WhatsApp URL',
    date: '08/2018',
    online: true,
    opensource: true,
    repo: 'https://github.com/nandomoreirame/app-whatsapp-url',
    image: 'whatsapp-url.png',
    url: 'https://whatsapp-url.netlify.com/',
    description: `WhatsApp URL é um simples WebApp desenvolvido utilizando VueJS como tecnologia e com o propósito de estudo. O código é open-source e pode ser encontrado no Github.`,
    tags: [
      'Vue',
      'Vuejs',
      'Vuex',
      'ECMAScript6',
      'OpenSource',
      'Netlify'
    ]
  },
  {
    name: 'Nuxt Brasil',
    date: '08/2018',
    online: true,
    opensource: true,
    repo: 'https://github.com/nuxtjsbrasil/nuxtjsbrasil.github.io',
    image: 'nuxt.com.br.png',
    url: 'https://nuxt.com.br/',
    description: `Idealizador e mantenedor do grupo de usuários brasileiros Universal Vue.js Applications // Nuxt Brasil`,
    tags: [
      'Vue',
      'Vuejs',
      'Nuxt',
      'NuxtBrasil',
      'Netlify'
    ]
  },
  {
    name: 'Projeto nandomoreira.me (nuxt theme)',
    date: '05/2018',
    online: true,
    opensource: true,
    repo: 'https://github.com/nandomoreirame/nandomoreira.me-nuxt-theme',
    image: 'nandomoreira.me-nuxt-theme.png',
    url: 'https://nuxt-theme-nandomoreirame.netlify.com/',
    description: `🏃 My superfast personal SPA blog/site using Vuejs and Nuxt :D -- Projeto escrito em VueJS utilizando NuxtJS para gerar os arquivos estáticos e hospeda-los n0 Netlify. O código é totalmente Open Source sob licença MIT.`,
    tags: [
      'VueJS',
      'Vuex',
      'NuxtJS',
      'ECMAScript6',
      'OpenSource',
      'Netlify'
    ]
  },
  {
    name: 'Ferramentas Digital',
    date: '11/2017',
    online: true,
    opensource: true,
    repo: 'https://github.com/iFundamental/tools.github.io',
    image: 'ferramentas.digital.png',
    url: 'http://ferramentas.digital',
    description: `Desenhado no Sketch, desenvolvido com Jekyll e hospedado no Netlify, o Growth Tools é um repositório de ferramentas para Growth Hackers.`,
    tags: [
      'UXDesign',
      'SketchApp',
      'Jekyll',
      'FrontEnd',
      'Tools',
      'OpenSource'
    ]
  },
  {
    name: 'Chuck Norris jokes',
    date: '07/2017',
    online: true,
    opensource: true,
    repo: 'https://github.com/nandomoreirame/chucknorris-jokes',
    image: 'chucknorris-jokes.png',
    url: 'https://chucknorris-jokes.nandomoreira.me',
    description: `O projeto Chuck Norris jokes foi um projeto para aperfeiçoamento das minhas habilidades com ECMAScript 6 e VueJS/Vuex. O código é totalmente Open Source sob licença MIT.`,
    tags: [
      'Vuejs',
      'Vue',
      'Vuex',
      'ES6',
      'FrontEnd'
    ]
  },
  {
    name: 'Portal da comunidade PHPPR',
    date: '04/2017',
    online: true,
    opensource: true,
    repo: 'https://github.com/phppr/theme-phppr.org',
    image: 'phppr.png',
    url: 'https://phppr.org',
    description: `Design e desenvolvimento do tema WordPress para Portal do Grupo de Desenvolvedores PHP do Paraná.`,
    tags: [
      'Comunidade',
      'OpenSource',
      'WordPress',
      'WordPressTheme',
      'FrontEnd',
      'PHPPR',
      'PHP'
    ]
  },
  {
    name: 'Lorem Gemidão do zap ipsum',
    date: '01/2017',
    online: true,
    opensource: true,
    repo: 'https://github.com/nandomoreirame/lorem-gemidao-do-zap-ipsum',
    image: 'lorem-gemidao-do-zap-ipsum.png',
    url: 'https://lorem-gemidao-do-zap-ipsum.netlify.com',
    description: `ÕÕÕHH ÕÕÕHH ÕÕÕAHH ÕÕÕAHH ÃÃÃHNN ÃÃÃHNN HÃÃÃÃN ÕÕÕHH ÕÕÕAHH HÃÃÃÃN HÃÃÃÃN ÕÕÕHH. ÕÕÕHH HÃÃÃÃN ÃÃÃHNN HÃÃÃÃN ÃÃÃHNN ÕÕÕHH. 😜😂`,
    tags: [
      'VueJS',
      'VueX',
      'ECMAScript6',
      'GithubPages',
      'OpenSource',
      'FrontEnd'
    ]
  },
  {
    name: 'end2end - Jekyll Theme ',
    date: '01/2017',
    online: true,
    opensource: true,
    repo: 'https://github.com/nandomoreirame/end2end',
    image: 'end2end.png',
    url: 'https://nandomoreirame.github.io/end2end/',
    description: `💎 Clean Jekyll theme `,
    tags: [
      'Jekyll',
      'Theme',
      'JekyllTheme',
      'Free',
      'Download',
      'OpenSource',
      'FrontEnd'
    ]
  },
  {
    name: 'Middleman blog',
    date: '05/2016',
    online: true,
    opensource: true,
    repo: 'https://github.com/nandomoreirame/middleman-blog',
    image: 'middleman-blog.png',
    url: 'https://nandomoreirame.github.io/middleman-blog/',
    description: `Projeto escrito em Middleman utilizando GulpJS para automatizar tarefas de CSS, JavaScript e hospeda-los no Github pages.`,
    tags: [
      'Ruby',
      'Middleman',
      'GulpJS',
      'OpenSource',
      'FrontEnd'
    ]
  },
  {
    name: 'Novo front-end do site da comunidade GuruPR',
    date: '04/2016',
    online: true,
    opensource: true,
    repo: 'https://github.com/guru-pr/gurupr',
    image: 'gurupr.png',
    url: 'https://gurupr.org/',
    description: `Novo design e desenvolvimento front-end do site do Grupo de Usuários Ruby do Paraná.`,
    tags: [
      'Ruby',
      'RubyOnRails',
      'Comunidade',
      'OpenSource',
      'FrontEnd'
    ]
  },
  {
    name: 'Simplest - Jekyll theme',
    date: '12/2015',
    online: true,
    opensource: true,
    repo: 'https://github.com/nandomoreirame/simplest',
    image: 'simplest-jekyll-theme.png',
    url: 'https://nandomoreirame.github.io/simplest/',
    description: `Como o nome diz, Simplest é um tema simples para criar blog utlizando a plataforma Jekyll.`,
    tags: [
      'Jekyll',
      'Blogging',
      'Blog',
      'FreeTheme',
      'GithubPages',
      'Download',
      'OpenSource'
    ]
  },
  {
    name: 'Blog Wilson Luiz Prosdocimo',
    date: '12/2015',
    online: true,
    opensource: true,
    repo: 'https://github.com/Wprosdocimo/wprosdocimo.github.io',
    image: 'wprosdocimo.com.br.png',
    url: 'http://wprosdocimo.com.br',
    description: `Desenvolvimento do blog do Wilson Luiz Prosdocimo utilizando a plataforma Jekyll e hospedando no Github pages.`,
    tags: [
      'Jekyll',
      'Blogging',
      'Blog',
      'GithubPages',
      'OpenSource'
    ]
  },
  {
    name: 'dotX - Jekyll theme',
    date: '12/2015',
    online: true,
    opensource: true,
    repo: 'https://github.com/nandomoreirame/dotX/',
    image: 'dotx.png',
    url: 'https://nandomoreirame.github.io/dotX/',
    description: `Tema simples e clean para Jekyll`,
    tags: [
      'Jekyll',
      'Blogging',
      'Blog',
      'FreeTheme',
      'GithubPages',
      'Download',
      'OpenSource'
    ]
  },
  {
    name: 'Fernando Moreira - Jekyll theme',
    date: '11/2015',
    online: true,
    opensource: true,
    repo: 'https://github.com/nandomoreirame/nandomoreira-jekyll-theme',
    image: 'nandomoreira-jekyll-theme.png',
    url: 'https://nandomoreirame.github.io/nandomoreira-jekyll-theme/',
    description: `Esse é o projeto do meu antigo blog feito com Jekyll, está totalmente open source e hospedado no Github pages.`,
    tags: [
      'Jekyll',
      'FreeTheme',
      'Free',
      'Download',
      'Blog',
      'Blogging',
      'GithubPages',
      'OpenSource'
    ]
  }
]
